<template>
<li class="product-slider__item">
  <component :is="productItem.isLink === true ? 'router-link' : 'div'"
    class="product-slider__link" :to="{name: productItem.path}">
    <div class="product-slider__img">
      <img class="product-slider__img-pic" alt="slide" :src="productItem.picture">
    </div>
    <h4 class="product-slider__text">
      {{productItem.name}}
    </h4>
  </component>
</li>
</template>

<script>
export default {
  props: {
    productItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
$white: #FFFFFF;

.product-slider {
  &__text {
    color: $white;
    text-transform: uppercase;
    background: rgba(77, 45, 45, 0.3);
    width: 100%;
    padding: 10px 17px 28px;
    border-radius: 0px 0px 5px 5px;
    font-family: 'montserratbold', sans-serif;
    font-size: 14px;
    line-height: 22px;
    position: absolute;
    bottom: 0;
    max-height: 75px;
    height: 100%;

    .class-ways__slider & {
      position: initial;
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
      font-family: 'montserratregular', sans-serif;
      border-radius: 0;
      padding: 10px 9px 12px;
      height: 41px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      @media (max-width: 377px) {
        font-size: 11px;
        line-height: 15px;
      }
    }

    .class-ways__slider.coral & {
      background: #FF7D75;
    }

    .class-ways__slider.blue & {
      background: #4DB6BC;
    }

    .class-ways__slider.violet & {
      background: #8293E8;
    }
  }

  &__img {
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    .class-ways__slider & {
      height: 172px;
    }

    &-pic {
      width: 100%;
      object-fit: cover;
      height: 100%;
    }
  }
  &__link {
    .class-ways__slider & {
      display: flex;
      flex-direction: column;
    }
  }

  &__item {
    overflow: hidden;
    position: relative;
    z-index: 20;
    margin: 0 25px 0 0;
    width: 100%;
    border-radius: 10px;
    cursor: pointer;
    height: 234px;

    &:last-child {
      margin: 0;
    }

    .class-ways__slider & {
      width: 162px;
      height: 216px;

      @media (max-width: 822px) {
        margin: 0 25px 30px 0;
      }
      @media (max-width: 590px) {
        margin: 0 15px 30px 0;
      }
      @media (max-width: 377px) {
        margin: 0 7px 30px 0;
        width: 158px;
      }
      @media (max-width: 353px) {
        margin: 0 7px 30px 0;
        width: 140px;
      }
    }

    .class-ways__slider.coral & {
      border: 2px solid #FF7D75;
    }

    .class-ways__slider.blue & {
      border: 2px solid #4DB6BC;
    }

    .class-ways__slider.violet & {
      border: 2px solid #8293E8;
    }

    @media (max-width: 880px) {
      width: 32%;
    }

    @media (max-width: 820px) {
      width: 49%;
    }

    @media (max-width: 580px) {
      width: 86%;
    }
  }
}

</style>
